/** @jsx jsx */
import { jsx } from '@emotion/react';

import type { MutableRefObject, ReactNode } from 'react';

import type { Button } from '@coursera/event-pulse-types';
import { useTracker, useVisibilityTracker } from '@coursera/event-pulse/react';

import Pill from 'bundles/browse-common/components/Pill/Pill';

type TrackingData = {
  button: Button;
};

type TrackedPillProps = {
  children: ReactNode;
  href: string;
  trackingData: TrackingData;
  className?: string;
};

const TrackedPill = ({ children, href, trackingData, className }: TrackedPillProps) => {
  const track = useTracker();
  const ref: MutableRefObject<HTMLButtonElement | null> = useVisibilityTracker('view_button', trackingData);

  const trackClick = () => {
    track('click_button', trackingData);
  };

  return (
    <Pill ref={ref} href={href} onClick={trackClick} className={className}>
      {children}
    </Pill>
  );
};

export default TrackedPill;
